import HomePage from './components/pages/HomePage';
import GraphPage from './components/pages/GraphPage';

export default [
  {
    path: '/',
    component: HomePage,
  },
  {
    path: '/graph/',
    component: GraphPage,
  },
];



// WEBPACK FOOTER //
// ./src/routes.js